import { Elements } from '@/components';
import ShieldIcon from '@icons/Shield.svg';
import Image from 'next/image';
import { CORE_VALUES } from '@utils/constants';
export const OurMission = () => {
    return (
        <section className="overflow-hidden bg-brand-50 px-5 pb-15 md:px-10 lg:px-[79px]">
            <div className="mx-auto flex w-full max-w-[1200px] flex-col items-center justify-between gap-10">
                <div className="flex flex-col items-center justify-center gap-4">
                    <Elements.Title title="Our Mission" type="h1" className="text-center text-gray-900" />
                    <Elements.Description
                        description="Our mission is to empower brokers, agencies, TPAs, and carriers to easily and efficiently design and administer ICHRA plans. We provide a modern, user-friendly platform that simplifies the complex process of ICHRA plan design and administration, allowing businesses to focus on what they do best while we handle the rest."
                        type="medium"
                        className="max-w-[680px] text-center text-gray-900"
                    />
                </div>

                <div className="flex max-w-[1200px] flex-col items-center justify-between gap-4 rounded-3xl border border-gray-200 bg-white p-10 shadow-[4px_3px_11px_0px_#0000001A,15px_13px_20px_0px_#00000017,34px_30px_27px_0px_#0000000D,60px_53px_32px_0px_#00000003,94px_84px_35px_0px_#00000000]">
                    <Elements.Title title="Core Values" type="h3" className="text-center text-gray-900" />

                    <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-3">
                        {CORE_VALUES.map((value) => (
                            <Elements.CoreValueCard
                                key={value.title}
                                title={value.title}
                                description={value.description}
                                icon={
                                    <Image
                                        src={ShieldIcon}
                                        alt={value.title}
                                        width={20}
                                        height={20}
                                        className="w-8 h-8"
                                    />
                                }
                            />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};
